@if ( props.addonLeft) {
<ng-template #matPrefix>
    @if (!!props.addonLeft.onClick && props.addonLeft.icon ) {
    <button type="button" mat-icon-button matPrefix (click)="addonLeftClick($event)"
        [attr.aria-label]="props.addonLeft.ariaLabel ?? props.addonLeft.icon ?? ''">
        <mat-icon color='primary'>{{ props.addonLeft.icon }}</mat-icon>
    </button>
    }
    @if (!props.addonLeft.onClick && props.addonLeft.icon) {
    <mat-icon matPrefix color='primary'>{{ props.addonLeft.icon }}</mat-icon>
    }
    @if( props.addonLeft.text ) {
    <span matTextPrefix class="mutara-addon">{{ props.addonLeft.text }}</span>
    }
    <!--(click)="!!props.addonLeft.onClick? addonLeftClick($event) : function(){return}"-->
</ng-template>
}

<ng-container #fieldComponent></ng-container>

@if (props.addonRight) {
<ng-template #matSuffix>
    @if (!!props.addonRight.onClick && props.addonRight.icon ) {
    <button type="button" mat-icon-button matSuffix (click)="addonRightClick($event)"
        [attr.aria-label]="props.addonRight.ariaLabel ?? props.addonRight.icon ?? ''">
        <mat-icon color='primary'>{{ props.addonRight.icon }}</mat-icon>
    </button>
    } @else {
    @if (!props.addonRight.onClick && props.addonRight.icon) {
    <mat-icon matSuffix color='primary'>{{
        props.addonRight.icon }}</mat-icon>
    }
    @if (!!props.addonRight.text) {
    <span matTextSuffix class="mutara-addon">{{ props.addonRight.text }}</span>
    }
    }
    <!--(click)="!!props.addonRight.onClick ? addonRightClick($event) : function(){return}"-->
</ng-template>
}